import { useAppSelector } from "lib/store";
import useMount from "react-use/lib/useMount";
import ModalTitle from "../ModalTitle";
import {
  getActiveNotificationsMessagesById,
} from "_slices/notifications";
import { useNotificationLocation } from "lib/hooks/useNotificationLocation";
import logRepContact from "lib/ga/repContact"

import Contact from "../Contact";
import globalStyles from '../modal.module.css';
import styles from './localAgents.module.css';

type Props = {
  title: string,
  subTitle: string,
  property: {
    name: string,
    type: string,
    id: string,
    hasBid: boolean
    address: {
      line2: string,
      line1: string,
      postcode: string,
      town_name: string
    }
  },
  user: {
    forename: string,
    surname: string,
    email: string,
    telephone: string,
    company: {
      name: string
    }
  }
  agentList: [],
  closeModal: any
}

const LocalAgentsContact = ({ title, subTitle, property, user, agentList, closeModal }: Props) => {
  title = title || "Schedule a Call";
  subTitle = subTitle || "";

  let notification_id = 'MODAL_PROPERTY_LOCAL_CONTACT_FORM';
  const [sendSuccess, activeNotifications] = useNotificationLocation(notification_id);


  useMount(() => {
    // Log that the modal has been opened and how is being contacted
    logRepContact({
      type: "local_agents",
      state: "opened",
      target: '',
      id: property?.id,
      subject_type: property?.type
    });
  })


  return <>
    <ModalTitle title={title} subTitle={`This contact form will put you in touch with local retail agents who operate in ${property?.address?.town_name}.`}  containerMargin="1rem" className={globalStyles.localExperts} />
    {!sendSuccess && activeNotifications &&
      activeNotifications.map((id) => {
        return <NotificationMessage key={id} id={id} />;
      })}
    
    <div className={styles.FormTitle}>
      Fill in the form if you're looking for retail property in this area and agents may get in touch if they're able to help.
    </div>

    <Contact googleCat='Property Local Agent' googleType='local_agents' property={property} user={user} agentList={agentList} closeModal={closeModal} agentId={null} />
  </>
};

export default LocalAgentsContact;

interface NotificationMessageProps {
  id: string;
}
const NotificationMessage = ({ id }: NotificationMessageProps) => {
  let messages = useAppSelector((state) => getActiveNotificationsMessagesById(id, state));

  return (
    <div className={globalStyles.AlertDanger} key={id}>
      {messages.map((message) => {
        return <div key={id}>{message}</div>;
      })}
    </div>
  );
};
